import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mentalhealth',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './mentalhealth.component.html',
  styleUrls: ['./mentalhealth.component.scss']
})
export class MentalhealthComponent {
  constructor(private translate: TranslateService) {}
}
